export const SET_MENU_LIST = 'SET_MENU_LIST'